import { BlurEvent, ContextMenuCreationEvent, DataDisplayEvent, DataSourceExecutionEvent, DataSourceMode, DropdownSelectionEvent, Layout, LookupModelSearchEvent, LookupModelSelectionEvent, TableRowDisplayEvent, Textbox, ValidationResult } from "@mcleod/components";
import { ModelRow, RowUpdateEvent } from "@mcleod/core";
import { CarrierAction } from "./CarrierAction";
import { ModelCarrierObjection } from "@mcleod/crm";
import { AutogenLayoutSalesExpand } from "./autogen/AutogenLayoutSalesExpand";
import { ModelObjection } from "./models/ModelObjection";
import { ProspectAction } from "./ProspectAction";
import { SendInfoPacket } from "./SendInfoPacket";

export class SalesExpand extends AutogenLayoutSalesExpand {

    onLoad(): void | Promise<void> {
        this.textboxActionDate.addlValidationCallback = (value: string, mode: DataSourceMode) => {
            const result:ValidationResult = { component: this.textboxActionDate, isValid: true };
            if (mode !== DataSourceMode.SEARCH) {
                const actionDate = this.activeRow?.getDate(this.textboxActionDate.field, null);
                const now = new Date();
                if (actionDate && actionDate > now) {
                    result.isValid = false;
                    result.validationMessage = "Action Date cannot be in the future.";
                }
            }
            return result;
        };

        this.textboxObjectionId1.quickInfoOverrideSearchMethod = async (layout: Layout, _keyValue: any) =>
            layout.mainDataSource.search({id: _keyValue, type_of: "C"});

        this.textboxObjectionId2.quickInfoOverrideSearchMethod = async (layout: Layout, _keyValue: any) =>
            layout.mainDataSource.search({id: _keyValue, type_of: "C"});
    }

    textboxStatusOnDataDisplay(event: DataDisplayEvent) {
        this.textboxRemarks.required = ("C" === event.rowData?.getString("status", null));
    }

    textboxStatusAfterDropdownSelection(event: DropdownSelectionEvent) {
        if ("P" === event.selection.value){
            this.activeRow.set("action_date", null);
        } else {
            this.activeRow.set("action_date", new Date());
        }
        this.textboxRemarks.required = ("C" === event.selection.value);
    }
    textboxObjectionId1OnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxObjection1Script.text = event.hasSelection() ? event.getValueFromSelectedRow("response_script") : null;
    }

    textboxObjectionId2OnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxObjection2Script.text = event.hasSelection() ? event.getValueFromSelectedRow("response_script") : null;
    }

    sourceProspectActionAfterExection(event: DataSourceExecutionEvent) {
        if (this.activeRow) {
            this.syncNextActivity();
            this.activeRow.addAfterPostListener((event: RowUpdateEvent) => SendInfoPacket.checkInfoPacket(event.row));
        }
    }

    textboxDateDueOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            this.syncNextActivity();
        }
    }

    customerTypeSearchFilter(event: LookupModelSearchEvent) {
        event.filter.type_of = "C";
    }

    textboxNextActIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.id = "!RECCALL";
        this.customerTypeSearchFilter(event);
    }

    async textboxNextActionAfterDropdownSelection(event: DropdownSelectionEvent) {
        await this.syncNextActivity();
        if (event.hasSelection()) {
            this.textboxNextActId.required = true;
            this.textboxNextActDate.required = true;
            switch (event.selection.value) {
                case "A":
                    this.activeRow.setValues({
                        "next_act_id": null,
                        "next_act_date": null
                    });
                    this.textboxNextActId.clear();
                    this.textboxNextActDate.clear();
                    this.textboxNextActId.enabled = true;
                    this.textboxNextActDate.enabled = true;
                    break;
                case "U":
                    this.textboxNextActId.enabled = false;
                    this.textboxNextActDate.enabled = true;
                    break;
            }
        } else if (event.hasDeselection()) {
            this.textboxNextActId.enabled = this.textboxNextActId.required = false;
            this.textboxNextActDate.enabled = this.textboxNextActDate.required = false;
        }
    }

    syncNextActivity() {
        const actionId = this.activeRow.getString("id", null);
        const customerId = this.activeRow.getString("customer_id", null);
        const dateDue = this.activeRow.getDate("date_due", null);
        const opportunityId = this.activeRow.get("opportunity_id", null);
        return ProspectAction.findNextActivity(actionId, customerId, dateDue, opportunityId).then((nextActivity) => {
            if (nextActivity.id) {
                this.activeRow.setValueAndLookupModelData("next_act_id", nextActivity.id, { "id": nextActivity.id, "descr": nextActivity.descr });
                this.activeRow.set("next_act_date", nextActivity.date_due);
            } else {
                this.activeRow.setValues({
                    "next_act_id": null,
                    "next_act_date": null
                });
            }
            this.textboxNextActId.displayComponentData(this.activeRow, null, 0);
            this.textboxActionDate.displayComponentData(this.activeRow, null, 0);
        });
    }
}
